// @flow
import { all, fork, put, takeEvery, call } from 'redux-saga/effects';

import {
    getConfSurvey as getConfSurveyAPI,
    updateConfSurvey as updateConfSurveyAPI,
} from '../../helpers/';

import { confSurveysApiResponseError, confSurveysApiResponseSuccess } from './actions';
import { ConfSurveysActionTypes } from './constants';


/**
 * Get confSurvey
 * @param {*} payload - username and password
 */
function* getConfSurvey({ payload: { confSurveyId, destination } }) {
    try {
        const response = yield call(getConfSurveyAPI, confSurveyId, destination);
        const confSurvey = response.data.data;
        yield put(confSurveysApiResponseSuccess(ConfSurveysActionTypes.GET_CONF_SURVEY, confSurvey));
    } catch (error) {
        yield put(confSurveysApiResponseError(ConfSurveysActionTypes.GET_CONF_SURVEY, error));
    }
}

function* updateConfSurvey({ payload: confSurvey }) {
    try {
        const response = yield call(updateConfSurveyAPI, { ...confSurvey })
        const confSurveyItem = response.data.data
        yield put(confSurveysApiResponseSuccess(ConfSurveysActionTypes.UPDATE_CONF_SURVEY, confSurveyItem))
    } catch (error) {
        yield put(confSurveysApiResponseError(ConfSurveysActionTypes.UPDATE_CONF_SURVEY, error))
    }
}

export function* watchGetConfSurvey(): any {
    yield takeEvery(ConfSurveysActionTypes.GET_CONF_SURVEY, getConfSurvey);
}

export function* watchUpdateConfSurvey(): any {
    yield takeEvery(ConfSurveysActionTypes.UPDATE_CONF_SURVEY, updateConfSurvey)
}

function* confSurveysSaga(): any {
    yield all([
        fork(watchGetConfSurvey),
        fork(watchUpdateConfSurvey)
    ]);
}

export default confSurveysSaga;
